var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 808,
    height: 808,
    viewBox: "0 0 808 808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-custom_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 808,
    height: 808
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom_3",
    "data-name": "custom \\u2013 3",
    clipPath: "url(#clip-custom_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M117.192,793.3a25.454,25.454,0,0,1-12.935-3.552,27.087,27.087,0,0,1-13.14-23.391V65.873a27.087,27.087,0,0,1,13.14-23.391,25.627,25.627,0,0,1,26.2.184L704.072,392.911a27.426,27.426,0,0,1,0,46.413L130.458,789.567a25.655,25.655,0,0,1-13.266,3.735Zm26.074-680.229V719.161L639.554,416.118Z",
    transform: "translate(-0.117 -11.972)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.e84ef7dc21c01f58814e0f66ddffcd95.svg";
export { ForwardRef as ReactComponent };